<!-- 收货明细-商品明细详情弹出框 -->
<template>
  <van-overlay :show="show" @click="onSendClose">
    <div class="content" v-if="info" @click.stop>
      <div class="tool">
        <label>商品明细</label>
        <i class="iconfont guanbi" @click="onSendClose"></i>
      </div>
      <div class="content-item flex">
        <section class="search-tool">
          <van-field v-model="slCode" autofocus clearable/>
          <span @click="onSearch">扫描库位</span>
        </section>
      </div>
      <div class="content-main mt-5">
        <section>
          <label>商品名称</label>
          <label>{{ info.productName }}</label>
        </section>
        <section>
          <label>国际编码</label>
          <label>{{ info.barCode }}</label>
        </section>
        <section>
          <label>板号</label>
          <label>{{ info.bandSn }}</label>
        </section>
        <section>
          <label>库位</label>
          <label>{{ info.slCode }}</label>
        </section>
      </div>
      <div class="header mt-5" v-show="showResult">
        <section>库区 : {{ storageLocation.storageZone.szCode }}</section>
        <section>库位 : {{ storageLocation.slCode }}</section>
      </div>
      <div class="sub-tool">
          <label @click="handleConfirm">确认上架</label>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  data() {
    return {
      slCode: '',
      showResult: false,
      storageLocation: {
        storageZone: {
          szCode: ""
        },
      },
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: function () {
        return {
          goodsInfoResponseVO: {}
        };
      }
    }
  },
  methods: {
    // 发送关闭事件
    onSendClose() {
      this.slCode = "";
      this.showResult = false;
      this.storageLocation = {
        storageZone: {
          szCode: ""
        },

       }
      this.$emit("closeDialog");
    },

    // 搜索
    onSearch() {
      let requestUrl = this.URL.findBySlCode;
      let param = {
        id: localStorage.getItem("ownWarehouseId")
      };
      param.strValue = this.slCode;
      this.$post(requestUrl, param).then(res => {
        if (res.success) {
          this.showResult = true;
          this.storageLocation = res.data;
        } else {
          this.$toast.fail(res.message);
        }
      });
    },

    handleConfirm() {
      let requestUrl = this.URL.shelvesSubmit;
      let param = {
        id: this.info.id,
        slId: this.storageLocation.id
      }
      this.$post(requestUrl, param).then(res => {
        if (res.success) {
          this.$toast.success("上架成功");
          this.onSendClose();
        } else {
          this.$toast.fail(res.message);
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.van-overlay {
  padding: 3rem 1rem 1rem 1rem;
}

.content {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
  background-color: white;
  border-radius: 0.3rem;
  color: #444;

  .tool {
    display: flex;
    width: 100%;
    justify-content: space-between;
    height: 2.6rem;
    align-items: center;
    padding: 0 0.5rem;
    font-size: 0.9rem;
    border-bottom: 1px solid #eee;

    i {
      font-size: 0.9rem;
    }
  }

  .header {
    border: 1px solid #dc6350;
    border-radius: 0.5rem;
    display: flex;
    width: 100%;
    flex-flow: column;
    margin: 0 0.5rem;
    padding: 0.5rem;
  }
}

.content-item {
  height: 2.5rem;
  align-items: center;
  border: 1px solid #f0f0f0;
  border-radius: 0.5rem;
  margin: 0.5rem;
}

.content-main {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 0.5rem;

  section {
    display: flex;
    width: 100%;
    height: 2.5rem;
    align-items: center;
    font-size: 0.85rem;

    label:first-child {
      display: inline-flex;
      width: 5rem;
    }

    .van-cell {
      padding: 0;
      border: 1px solid #f0f0f0;
      border-radius: 0.2rem;
      width: 13rem;
      padding-left: 0.5rem;
      line-height: 2rem;
    }

    .van-radio-group {
      display: flex;
      width: 100%;
      padding-left: 0.5rem;
    }

    .van-radio {
      width: 6rem;
    }

    .date {
      border: 1px solid #f0f0f0;
      border-radius: 0.2rem;
      width: 13rem;
      padding-left: 0.5rem;
      box-sizing: border-box;
      line-height: 2rem;
    }
  }
}

.sub-tool {
  display: flex;
  width: 100%;
  height: 3rem;
  align-content: center;
  justify-content: flex-end;
  padding-right: 1rem;
  border-top: 1px solid #eee;
  align-items: center;
  margin-top: 5rem;

  label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 2rem;
    background-color: #dc6350;
    color: white;
    font-size: 0.9rem;
    border-radius: 0.3rem;
    margin-left: 1.5rem;
    padding: 0 0.5rem;
  }
}

.search-tool {
  display: flex;
  width: 100%;
  height: 2.5rem;
  align-items: center;
  border-radius: 0.5rem;
  padding-left: 1rem;
  margin: 0.3rem 0;

  .van-cell {
    display: inline-flex;
    align-items: center;
    height: 2.2rem;
    padding: 0;
  }

  .van-cell:not(:last-child)::after {
    border-bottom: none;
  }

  span {
    display: inline-flex;
    height: 2.5rem;
    align-items: center;
    justify-content: center;
    width: 8rem;
    font-size: 0.9rem;
    border-left: 1px solid #f0f0f0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/receivingShelveDialog.vue